import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'formik';

import Grid from '@material-ui/core/Grid';
import { LabelTooltip } from 'core/components/label-tooltip';
import { FormField } from 'core/components/form';

const LouisianaAutoLimits = ({ id, disabled, UMBIOptions }) => {
  return (
    <Grid item xs={6}>
      <LabelTooltip
        label="Un/Underinsured Motorist BI"
        tooltip={{
          label: 'More Info',
          onHoverText:
            "This is the max we'll pay for medical expenses per person injured / per accident in the event you are in an accident with someone who doesn't have insurance (or enough insurance). Economic losses are those that can be measured in specific monetary terms including but not limited to medical costs, funeral expernses, lost wages, and out of pocket expenses."
        }}
      >
        <FormField
          mode="dark"
          name={`${id}.policyLimitUMBI`}
          id={`${id}.policyLimitUMBI`}
          type="select"
          options={UMBIOptions}
          optional
          disabled={disabled}
          fast={false}
        />
      </LabelTooltip>
    </Grid>
  );
};

LouisianaAutoLimits.propTypes = {
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  UMBIOptions: PropTypes.array.isRequired
};

LouisianaAutoLimits.defaultProps = {
  disabled: false
};

export default connect(LouisianaAutoLimits);
